"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _featuredCardHeader = _interopRequireDefault(require("./featuredCardHeader"));
var _featuredCardBody = _interopRequireDefault(require("./featuredCardBody"));
var _featuredCardFooter = _interopRequireDefault(require("./featuredCardFooter"));
require("./featuredSPCard.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FeaturedSPCard = function FeaturedSPCard(_ref) {
  var serviceProvider = _ref.serviceProvider,
    adCount = _ref.adCount,
    postalCode = _ref.postalCode,
    raqUrl = _ref.raqUrl,
    profileUrl = _ref.profileUrl,
    reviewsUrl = _ref.reviewsUrl,
    onMount = _ref.onMount,
    showReviewsLink = _ref.showReviewsLink,
    LinkWrapperComponent = _ref.LinkWrapperComponent,
    dataTrackingPropsForProfileViews = _ref.dataTrackingPropsForProfileViews,
    dataTrackingPropsForRaqBtn = _ref.dataTrackingPropsForRaqBtn;
  var listedSinceYear = serviceProvider.onAngiesListSince.substring(0, 4);
  var singleFeaturedPro = adCount === 1;
  (0, _react.useEffect)(onMount);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-sp-card",
    id: "featured-sp-card-".concat(serviceProvider.serviceProviderId)
  }, /*#__PURE__*/_react["default"].createElement(_featuredCardHeader["default"], {
    singleFeaturedPro: singleFeaturedPro,
    serviceProviderId: serviceProvider.serviceProviderId,
    serviceProviderName: serviceProvider.name,
    profileUrl: profileUrl,
    LinkWrapperComponent: LinkWrapperComponent,
    dataTrackingPropsForProfileViews: dataTrackingPropsForProfileViews
  }), /*#__PURE__*/_react["default"].createElement(_featuredCardBody["default"], {
    singleFeaturedPro: singleFeaturedPro,
    serviceProviderId: serviceProvider.serviceProviderId,
    serviceProviderName: serviceProvider.name,
    raqUrl: raqUrl,
    LinkWrapperComponent: LinkWrapperComponent,
    profileUrl: profileUrl,
    reviewsUrl: reviewsUrl,
    description: serviceProvider.description,
    reviewCount: serviceProvider.reviewCount,
    postalCode: postalCode,
    starRating: serviceProvider.starRating,
    awards: serviceProvider.awards,
    ratings: serviceProvider.ratings,
    listedSinceYear: listedSinceYear,
    showReviewsLink: showReviewsLink,
    dataTrackingPropsForProfileViews: dataTrackingPropsForProfileViews,
    dataTrackingPropsForRaqBtn: dataTrackingPropsForRaqBtn
  }), /*#__PURE__*/_react["default"].createElement(_featuredCardFooter["default"], {
    serviceProviderId: serviceProvider.serviceProviderId,
    singleFeaturedPro: singleFeaturedPro,
    postalCode: postalCode,
    starRating: serviceProvider.starRating,
    awards: serviceProvider.awards,
    ratings: serviceProvider.ratings,
    listedSinceYear: listedSinceYear,
    raqUrl: raqUrl,
    LinkWrapperComponent: LinkWrapperComponent,
    dataTrackingPropsForRaqBtn: dataTrackingPropsForRaqBtn
  }));
};
FeaturedSPCard.propTypes = {
  adCount: _propTypes["default"].number.isRequired,
  serviceProvider: _propTypes["default"].shape({
    serviceProviderId: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired,
    reviewCount: _propTypes["default"].number,
    awards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      description: _propTypes["default"].string,
      images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        size: _propTypes["default"].string,
        url: _propTypes["default"].string
      }))
    })),
    description: _propTypes["default"].string,
    onAngiesListSince: _propTypes["default"].string,
    ratings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string,
      starRating: _propTypes["default"].number
    })),
    leafSlug: _propTypes["default"].string,
    starRating: _propTypes["default"].number
  }).isRequired,
  postalCode: _propTypes["default"].string.isRequired,
  raqUrl: _propTypes["default"].string.isRequired,
  profileUrl: _propTypes["default"].string,
  reviewsUrl: _propTypes["default"].string,
  onMount: _propTypes["default"].func,
  showReviewsLink: _propTypes["default"].bool,
  LinkWrapperComponent: _propTypes["default"].element,
  // Disabling this to allow generic object for unknown shapes
  // since these are arbitrary segment props.
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForRaqBtn: _propTypes["default"].object,
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForProfileViews: _propTypes["default"].object
};
FeaturedSPCard.defaultProps = {
  showReviewsLink: false,
  profileUrl: undefined,
  reviewsUrl: undefined,
  onMount: function onMount() {},
  LinkWrapperComponent: null,
  dataTrackingPropsForRaqBtn: {},
  dataTrackingPropsForProfileViews: {}
};
var _default = exports["default"] = FeaturedSPCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/featuredSPCard.js
// module id = 6468
// module chunks = 25